module.exports = __webpack_public_path__ + "img/patient-info-desktop-en.3b61a532.jpg";